import { render, staticRenderFns } from "./ComplianceDashboard.vue?vue&type=template&id=a6aebcca&scoped=true&"
import script from "./ComplianceDashboard.vue?vue&type=script&lang=js&"
export * from "./ComplianceDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6aebcca",
  null
  
)

export default component.exports